/* eslint-disable import/prefer-default-export */
import { SmallText } from 'modules/FreemiumWaitingLine/styles';
import { styled } from 'styled-components';

export const TicketNumberText = styled(SmallText)`
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.biggest};
`;
